import Footer from "./components/Footer";
import Header from './components/Header';
import Shop from './components/Shop';


export default function App () {
  return (
    <>
      <Header />
      <Shop />
      <Footer />
    </>
  );
}

